import { QuestionOutlined } from "@ant-design/icons"
import type { useAppProps } from "antd/es/app/context"
import type { TFunction } from "i18next"

import type { ArchiveQuestion } from "../../Projects/api/services.types.ts"
import { PendingCommitmentsAlert } from "../../Projects/components/PendingCommitmentsAlert.tsx"
import { archiveQuestionLabels } from "../../Projects/helpers/archive-question-labels.ts"

/** The diary question a refused close asks: what it would drop, and go ahead? */
export const confirmProjectCommitments = ({
  modal,
  t,
  question,
  onOk
}: {
  modal: useAppProps["modal"]
  t: TFunction
  question: ArchiveQuestion
  onOk: () => unknown
}) => {
  const labels = archiveQuestionLabels(question, "projectArchive", t)
  modal.confirm({
    centered: true,
    width: 520,
    icon: <QuestionOutlined />,
    title: String(labels.title),
    content: (
      <PendingCommitmentsAlert
        commitments={question.pendingCommitments}
        signatures={question.pendingSignatures}
      />
    ),
    cancelText: String(t("projectArchive.commitments.keepActive")),
    okText: String(labels.confirm),
    okButtonProps: { danger: true },
    onOk
  })
}
